import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class DeviceTypeGuard {
  constructor(
    private router: Router,
    private deviceDetectorService: DeviceDetectorService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    if (this.deviceDetectorService.isDesktop()) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
